var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
var __WEBPACK_NAMESPACE_OBJECT__ = x({ ["JSON_SCHEMA"]: () => __WEBPACK_EXTERNAL_MODULE_js_yaml_78384032__.JSON_SCHEMA, ["default"]: () => __WEBPACK_EXTERNAL_MODULE_js_yaml_78384032__["default"] });